import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Tabs from 'tailwind-components/Tabs/Tabs';
import {
  APPOINTED_CARRIERS_TAB_ID,
  getParentGroupLabel,
  getParentGroupTabId
} from 'helpers/carriers/carriers';
import { ALL_CARRIERS_TAB_ID } from './constants';

export default function CommissionsTabs({
  currentTab,
  setCurrentTab,
  handleResetActiveCarrier
}) {
  const { carriersArray } = useSelector(state => state.appointments);

  const tabList = useMemo(() => {
    const parentAppointmentGroups = new Set();

    carriersArray
      .filter(carrier => !!carrier.appointmentParentGroup)
      .forEach(carrier => {
        parentAppointmentGroups.add(carrier.appointmentParentGroup);
      });

    return [
      {
        id: APPOINTED_CARRIERS_TAB_ID,
        label: 'Appointed Carriers'
      },
      ...[...parentAppointmentGroups].map(group => ({
        id: getParentGroupTabId(group),
        label: getParentGroupLabel(group)
      })),
      {
        id: ALL_CARRIERS_TAB_ID,
        label: 'All Carriers'
      }
    ];
  }, [carriersArray]);

  return (
    <Tabs
      tabs={tabList}
      activeTabId={currentTab}
      onTabChange={id => {
        setCurrentTab(id);
        handleResetActiveCarrier();
      }}
      buttonClassName='font-medium'
      scrollButtons
      className='max-lg:justify-between'
    />
  );
}

CommissionsTabs.propTypes = {
  currentTab: propTypes.string.isRequired,
  setCurrentTab: propTypes.func.isRequired,
  handleResetActiveCarrier: propTypes.func.isRequired
};
